export enum SettingsEventType {
  UNSPECIFIED_SETTING_CHANGED,
  PROJECT_CHANGED,
  SPRINT_CHANGED,
  PROGRAM_CHANGED,
  PROGRAM_INCREMENT_CHANGED,
  RED_THRESHOLD_CHANGED
}
